import { AxiosResponse } from 'axios';
import AutoCategory from '~/domain/model/ServiceRequests/AutoCategory';
import Category from '~/domain/model/ServiceRequests/Category';
import SubCategory from '~/domain/model/ServiceRequests/SubCategory';
import { apiSession } from '~/services/api';

export const checkIfDeskManagerUserIsValid = (email: string) => {
  return apiSession.get<void, AxiosResponse<boolean>>(
    `desk-manager/check-if-user-exists`,
    { params: { email } }
  );
};

export type IFetchParams = {
  Pesquisa: string;
  Ativo: string;
  isProducer: boolean;
};

export const getServiceRequestsCategories = (params: IFetchParams) => {
  return apiSession.get<void, AxiosResponse<Category[]>>(
    `desk-manager/categories`,
    {
      params
    }
  );
};

export const getServiceRequestsSubCategories = (params: IFetchParams) => {
  return apiSession.get<void, AxiosResponse<SubCategory[]>>(
    `desk-manager/sub-categories`,
    {
      params
    }
  );
};

export const getServiceRequestsAutoCategories = (params: IFetchParams) => {
  return apiSession.get<void, AxiosResponse<AutoCategory[]>>(
    `desk-manager/auto-categories`,
    {
      params
    }
  );
};

export type ISendAttachmentFileParams = {
  Base64: string;
  FileName: string;
  FileSize: string;
};

export type AttachmentFileResponse = {
  Chave: string;
};

export type IChamado = {
  Email: string;
  Solicitacao: string;
  Assunto: string;
  AutoCategoria: string;
  Descricao: string;
  TicketNumber: string;
  Attachment: IAttachments[];
};

export type ICampoExtra = {
  accountCode: string;
  menuOrPageFailure: string;
  CompletName: string;
  InicialPeriod: string;
  FinalPeriod: string;
  gfpQuantity: number;
  requesterName: string;
};

export type ICreateServiceRequestParams = {
  TChamado: IChamado;
  TCampoExtra: ICampoExtra;
};

export type IServiceRequestResponse = string | { erro: string };

export const createServiceRequest = (params: ICreateServiceRequestParams) => {
  return apiSession.post<void, AxiosResponse<IServiceRequestResponse>>(
    `desk-manager/create-ticket`,
    params
  );
};

export type IAttachments = {
  base64: string;
  name: string;
  type: string;
}